import { api, writeDB } from './store';

export async function getAutoCancelStatus(): Promise<void> {
  const response = await api.showOrderAutoCancellation();
  writeDB.set('autoCancelDisabled', response.data.disabled);
}

export async function updateAutoCancelStatus(): Promise<void> {
  const disabled = !writeDB.get('autoCancelDisabled');
  await api.updateOrderAutoCancellation({ disabled });
  await getAutoCancelStatus();
}
